import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import logoImage from "../../../../../../assets/images/PalletTraderPlus.svg";
import LogoImage from "../../../../../../assets/svg/Logo";
import nounImage from "../../../../../../assets/images/noun-trending.svg";
import nounPartner from "../../../../../../assets/images/noun-partner.svg";
import connectImage from "../../../../../../assets/images/platform.png";
import {
  Container,
  Wrapper,
  ptplusModal,
} from "web/pages/public/landing-page/StartPage/EverStop/PalletPlusModal/PalletPlusModalStyled";
import styled from "styled-components";
function Example(args) {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const ptplusModal = {
    backgroundColor: "#f6af18",
    padding: "10px 50px",
    color: "#005586",
    fontWeight: "bold",
  };
  const imageClass = {
    width: "108px",
  };
  const imageDiv = {
    marginRight: "10px",
    width: "25%",
    height: "100px",
  };

  return (
    <>
      <ManageServiceOuterBox>
        <ManageServiceBox>
          <div className="imageWrapper">
            <center>
              {/* <img style={{ width: "100%" }} src={logoImage} /> */}

              <LogoImage className="ptlogoIcon" width={167} height={61} />
            </center>
          </div>
          <div className="textWrapper">
            <strong>
              Get all the benefits of PalletTrader, in a managed service.
            </strong>
          </div>

          <center>
            {" "}
            <Button className="showMeServiceBtn" color="white" onClick={toggle}>
              <strong>Show Me The Service</strong>
            </Button>
          </center>
        </ManageServiceBox>
      </ManageServiceOuterBox>

      <Modal
        isOpen={modal}
        toggle={toggle}
        {...args}
        size="lg"
        style={{ marginTop: "85px" }}
      >
        <PopupContainer
          onClick={() => {
            setModal(!modal);
          }}
        >
          <div className="Header">
            <div>
              <h6 style={{ fontSize: "16px", marginBottom: "5px" }}>
                Announcing
              </h6>
              <div>
                {/* <img src={logoImage} /> */}
                <LogoImage />
              </div>
            </div>
          </div>

          <div className="ptplusModal">
            <center>
              PalletTrader
              <span style={{ position: "relative", top: "-3px" }}>+</span> is
              the best of what the PalletTrader marketplace has to offer,
              managed for you.{" "}
            </center>
            <center>
              Tell us what you need, and we’ll secure pallet supply and oversee
              the order process.
            </center>
          </div>
          <div style={{ color: "#005586", padding: "", fontSize: "14px" }}>
            <br />
            <strong>How it works</strong>
            <ul style={{ listStyle: "disc", margin: "0", paddingLeft: "18px" }}>
              <li>
                Interactive online portal to request, modify and monitor your
                pallet orders, inception through delivery.
              </li>
              <li>
                Dedicated account representative to manage the order procurement
                process.
              </li>
              <li>
                Tracking team that will monitor your daily shipments to ensure
                on-time delivery.
              </li>
              <li>
                Centralized access to download and audit invoices and PODs, with
                robust reporting.
              </li>
              <li>
                {" "}
                KPI dashboard for at-a-glance order and cost trends by location,
                and across your network.
              </li>
            </ul>
            <br />
            <FooterContainer style={{ display: "flex" }}>
              <div style={{ flex: "1 1 100%" }}>
                <strong>What you'll get</strong>
                <div className="ThreePicBox">
                  <div className="InerBox">
                    <div>
                      <img
                        style={{ width: "80%" }}
                        src={connectImage}
                        alt=""
                      ></img>
                      <br></br>
                    </div>
                    <div style={{ textAlign: "center", lineHeight: "17px" }}>
                      <span
                        style={{
                          color: "#005586",
                          fontSize: "11px",
                          fontWeight: "bold",
                          lineHeight: "1px",
                        }}
                      >
                        PalletTrader platform and technology
                      </span>
                    </div>
                  </div>
                  <div className="InerBox">
                    <div>
                      <img src={nounPartner} alt=""></img>
                    </div>
                    <div style={{ textAlign: "center", lineHeight: "17px" }}>
                      <span
                        style={{
                          color: "#005586",
                          fontSize: "11px",
                          fontWeight: "bold",
                        }}
                      >
                        Dedicated Account Rep
                      </span>
                    </div>
                  </div>
                  <div className="InerBox">
                    <div>
                      <img src={nounImage} alt=""></img>
                      <br></br>
                    </div>
                    <div style={{ textAlign: "center", lineHeight: "17px" }}>
                      <span
                        style={{
                          color: "#005586",
                          fontSize: "11px",
                          fontWeight: "bold",
                        }}
                      >
                        Dashboard for complete transaction visibility
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  flex: "0 1 35%",
                  background: "#005586",
                  padding: "10px 15px",
                  color: "#ffffff",
                  textAlign: "center",
                  fontSize: "13px",
                }}
              >
                Want to learn more about how PalletTrader
                <span style={{ position: "relative", top: "-3px" }}>+</span> can
                work for you? Contact: <br></br>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#f7b018",
                  }}
                >
                  Kevin Kull <br></br>732-454-9790
                  <br />
                  kevin.kull@pallettrader.com
                </span>
              </div>
            </FooterContainer>
          </div>
        </PopupContainer>
      </Modal>
    </>
  );
}

export default Example;
const FooterContainer = styled.div`
  display: flex;
  .ThreePicBox {
    display: flex;
    margin-right: 20px;
    .InerBox {
      width: 33.3%;
      > div:first-child {
        height: 100px;
        text-align: center;

        img {
          object-fit: contain;
          max-width: 100%;
          height: auto;
          width: 70%;
        }
      }
    }
    @media (max-width: 991px) {
      margin-right: 0;
      margin-bottom: 10px;
    }
    @media (max-width: 500px) {
      .InerBox {
        > div:first-child {
          height: 80px;
        }
      }
    }
  }
  @media (max-width: 991px) {
    flex-direction: column;
  }
`;
const PopupContainer = styled.div`
  padding: 10px 60px 30px;
  cursor: pointer;
  .Header {
    display: flex;
    justify-content: center;
    > div {
      display: inline-block;
      padding: 10px 10px 20px;
      h6 {
        font-weight: 600;
        color: #f6af18;
      }
    }
  }
  .ptplusModal {
    padding: 5px 5px;
    background-color: #f6af18;
    color: #005586;
    font-weight: bold;
    @media (max-width: 991px) {
      padding: 10px;
      cursor: pointer;
    }
  }
  @media (max-width: 991px) {
    padding: 20px;
  }
`;
const ManageServiceOuterBox = styled.div`
  position: sticky;
  max-width: 1440px;
  top: 220px;
  /* margin: 0 0 0 auto; */
  margin: 0 auto;
  z-index: 1;
  margin-top: -208px;
  display: flex;
  justify-content: flex-end;
  width: fit-content;
  margin-left: auto;
  margin-right: 0;
  top:380px;
  @media (min-width: 1441px) {
    width: fit-content;
    margin-right: calc(50vw - 720px);
  }
  @media (max-width: 1370px) {
    top:346px;
  }
  @media (max-width: 767px) {
    width: fit-content;
    margin-right: 0;
    top: 600px;
    margin-top: -137px;
  }

`;
const ManageServiceBox = styled.div`
  background: rgb(247, 176, 24);
  padding: 2px;
  width: 200px;
  .ptlogoIcon {
    aspect-ratio: auto 167/38;
    width: 100%;
    height: 38px;
  }
  .imageWrapper {
    background: #fff;
    padding: 5px 15px;
  }
  .textWrapper {
    color: #005586;
    text-align: center;
    /* padding: 10px 30px 10px 30px;
    font-size: 14px; */

    padding: 10px 30px 10px 30px;
    font-size: 16px;
  }

  .showMeServiceBtn {
    margin-bottom: 5px;
    font-size: 14px;
    background-color: white;
    border-radius: 10px;
    color: #005586;
    border: 1px solid transparent;
    :hover {
      border-color: blue;
      /* font-size: 14px; */
    }
  }
  @media (max-width: 767px) {
    width: 142px;
    .imageWrapper {
      padding: 0 15px;
    }
    .textWrapper {
      padding: 10px;
      font-size: 10px;
    }
    .showMeServiceBtn {
      font-size: 10px;
      border-radius: 8px;
    }
  }
`;
